import React from "react";
import GetByTransferNoResultsNotification
    from "@SearchResults/features/banners/features/getByTransferBanner/components/GetByTransferNoResultsNotification";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import ParamsType from "@/pages/searchResults/types/params/Params.type";

interface NoResultsWithGbtPromoProps {
    params: ParamsType,
    transfersData: TransfersDataType,
    showNoDirectRoutesNotification: boolean,
}

function NoResultsWithGbtPromo(props: NoResultsWithGbtPromoProps) {
    const {
        params,
        transfersData,
        showNoDirectRoutesNotification,
    } = props

    const {
        vehicles,
    } = transfersData || {}

    return (
        <GetByTransferNoResultsNotification
            showNotification={showNoDirectRoutesNotification}
            fromName={params.departureStation.name}
            toName={params.destinationStation.name}
            vehicles={vehicles}
        />
    )
}

export default NoResultsWithGbtPromo